class CookieBanner {
	constructor() {
		this.events();
	}

	events() {
		window.addEventListener("load", () => this.injectCSS());
	}

	async injectCSS() {
		const host = document.querySelector("#usercentrics-root");

		if (host && host.shadowRoot) {
			let sheet = await this.createSheet(eulenschmiedeData.theme_file_uri + "/css/cookie-banner.css");
			host.shadowRoot.adoptedStyleSheets.push(sheet);
		} else {
			console.log("There was no shadow root element found");
		}
	}

	async createSheet(source) {
		try {
			const response = await fetch(String(source));

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}

			const cssContent = await response.text();

			let sheet = new CSSStyleSheet();

			sheet.replaceSync(cssContent);

			return sheet;
		} catch (error) {
			console.log("There was a problem: ", error);
		}
	}
}

export default CookieBanner;
